<div>
  <fin-select-input
    [parentForm]="formGroup"
    [controlName]="'role'"
    [options]="roles$ | async"
    [selectLabelTranslationKey]="'CORPORATE.corporatePortal.addUser.fields.role.placeholder'"
    [translationPrefix]="'CORPORATE.corporatePortal.addUser.fields.role'"
  ></fin-select-input>
</div>
